<template>
    <Modal size="lg" modal-name="discussion-rules" :title="$t('discussions.rulesModal.title')">
        <div class="container-main container" v-html="$t('discussions.rulesModal.text')"></div>

        <div class="text-center">
            <button class="btn btn-primary btn-rounded-circle btn-sm py-1 px-4 mt-3" data-dismiss="modal" @click.prevent="hideModal">
                {{ $t('discussions.close') }}
            </button>
        </div>
    </Modal>
</template>

<script lang="ts">
import Modal from '~/components/Modal.vue'

export default {
    components: {
        Modal,
    },
    methods: {
        hideModal() {
            useNuxtApp().$bus.$emit('hideModal')
        },
    },
}
</script>
